import { useEffect } from 'react';

// Locks can overlap and release in any order (a dialog opened from the mobile sheet can outlive
// it), so the page scrolls again only when the last one releases
let locks = 0;
let unlockedOverflow = '';

export function useScrollLock(isLocked = true) {
  useEffect(() => {
    if (!isLocked) return;
    if (locks === 0) unlockedOverflow = document.body.style.overflow;
    locks += 1;
    document.body.style.overflow = 'hidden';
    return () => {
      locks -= 1;
      if (locks === 0) document.body.style.overflow = unlockedOverflow;
    };
  }, [isLocked]);
}
